import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export default function LoadingState({ label = 'Carregando' }) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, py: 6 }}
    >
      <CircularProgress size={28} aria-hidden="true" />
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}
